import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { getCanonicalUrl } from "../utils/seoConfig";

const Impressum = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('LegalNotice')} - Predsense</title>
        <link rel="canonical" href={getCanonicalUrl("/impressum")} />
      </Helmet>
      <div className="legal-section">
        <h1>{t('LegalNotice')}</h1>
        <div>
          <p>
            <strong>PredSense GmbH</strong>
            <br /> Ladestraße 2
            <br /> 6300 Wörgl
            <br /> {t('Austria')}
          </p>
          <p>
            Tel: +43 660 1599064
            <br /> Email: <a href="mailto:info@predsense.ai">info@predsense.ai</a>
            <br /> {t('ContactForm')}: <a href="/#contact">{t('ContactForm')}</a>
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>{t('BusinessPurpose')}:</strong> {t('BusinessPurpose') === 'Business purpose' ? 'Data processing and information technology' : 'Datenverarbeitung und Informationstechnik'}
            <br />
            <strong>{t('VATNumber')}:</strong> ATU81277823
            <br />
            <strong>{t('CompanyRegisterNumber')}:</strong> 637384f
            <br />
            <strong>{t('CommercialCourt')}:</strong> Landesgericht Innsbruck
            <br />
            <strong>{t('RegisteredOffice')}:</strong> 6300 Wörgl
          </p>
          <p>
            <strong>{t('ChamberOfCommerce')}:</strong> Wirtschaftskammer Österreich
            <br />
            <strong>{t('LegalRegulations')}:</strong> Gewerbeordnung: {" "}
            <a href="http://www.ris.bka.gv.at" target="_blank" rel="noreferrer">
              www.ris.bka.gv.at
            </a>
            <br />
            <strong>{t('SupervisoryAuthority')}:</strong> Bezirkshauptmannschaft Innsbruck
          </p>
          <p>
            <strong>{t('OnlineDispute')}:</strong>
            <br />
            {t('OnlineDispute')} Regulation (EU) No. 524/2013: <a href="http://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">http://ec.europa.eu/consumers/odr/</a>.<br />
            {t('InitialQuestionsDispute')} <a href="mailto:info@predsense.ai">info@predsense.ai</a>.
            <br /> &nbsp;
          </p>
          <h2>{t('MediaOwner')}</h2>
          <p>
            <strong>PredSense GmbH</strong>
            <br /> Ladestraße 2
            <br /> 6300 Wörgl
            <br /> {t('Austria')}
          </p>
          <p>
            <strong>{t('MediaOwnerPurpose')}:</strong>
            <br /> {t('BusinessPurpose') === 'Business purpose' ? 'Data processing and information technology' : 'Datenverarbeitung und Informationstechnik'}
          </p>
          <p>
            <strong>{t('EditorialDirection')}</strong>
          </p>
          <ul>
            <li>{t('Presentation')}</li>
            <li>{t('ProductInfo')}</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Impressum;
